/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        /**
         * First attempt is to work this using a table, which gives us good filtering control.
         * If the datasets get unweildy we may need to migrate to a UL.
         */
        class UserListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    
                    return new UserListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    
                    UserListWidgetInstanceClass.HtmlData = htmlData;
                    if (this.Instances != null && this.Instances.length > 0) {
                        
                        this.Instances.forEach(function (instance) {
                            instance.presentInstance();
                        });
                    }
                };
                
                // core.Loader.loadVersionedCSS('widgets/UserList/user-list.min.css');
                core.Loader.getVersionedHTML('widgets/UserList/user-list.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
            }
        }
        Widgets.UserListWidgetTypeClass = UserListWidgetTypeClass;
        class UserListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._contextBar = null;
                this._contextLabel = null;
                this._noRecords = null;
                this._tableBody = null;
                this._filterText = null;
                this._showOptionsSpan = null;
                this._hideOptionsSpan = null;
                this._editIcon = null;
                this._editControls = null;
                this._cancelButton = null;
                this._applyButton = null;
                this._showAllCheckbox = null;
                this._tableOptions = null;
                this._clearFilterButton = null;
                this._highlightSystemUsers = false;
                this._suppressContextBar = false;
                this._multiSelect = false; // If true, we are multi-selecting with checkboxes
                this._userListPopulated = false; // Set to true once the main table has been loaded
                this._removeProcessed = false; // Used to handle user group updates
                this._addProcessed = false; // Used to handle user group updates
                this._allUsers = [];
                this._groupUsers = [];
                this._currentGroupId = 0;
                this._currentGroup = null;
                this._lastSelectedUser = null;
                this._userIDsInGroup = [];
                this.presentInstance = () => {
                    
                    this._container.innerHTML = UserListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.hourglass-panel');
                    this._contextBar = this._container.querySelector('#userListContextBar');
                    this._contextLabel = this._container.querySelector('#userListContextLabel');
                    this._noRecords = this._container.querySelector('#userListNoRecords');
                    this._tableBody = this._container.querySelector('#userListTableBody');
                    this._filterText = this._container.querySelector('#userListFilter');
                    this._showOptionsSpan = this._container.querySelector('.showOptions');
                    this._hideOptionsSpan = this._container.querySelector('.hideOptions');
                    this._tableOptions = this._container.querySelector('.tableOptions');
                    this._clearFilterButton = this._container.querySelector('.clearFilterTextField');
                    this._editIcon = this._container.querySelector('#userListHeadingEdit');
                    this._editControls = this._container.querySelector('#userListEditControls');
                    this._cancelButton = this._container.querySelector('#userListCancelEdit');
                    this._applyButton = this._container.querySelector('#userListApplyEdit');
                    this._showAllCheckbox = this._container.querySelector('#userListShowAllCheckbox');
                    this._widgets.setTitle(this._config, this._container.querySelector('#userListHeading'), 'STR_WPT_USERS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#userListLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#userListNoRecordsLabel'), 'STR_WPT_NO_USERS');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showOptionsSpan.addEventListener('click', this._showOptions);
                    this._hideOptionsSpan.addEventListener('click', this._hideOptions);
                    this._editIcon.addEventListener('click', this._editList);
                    this._showAllCheckbox.addEventListener('change', this._showAllChanged);
                    this._cancelButton.addEventListener('click', this._cancelEdit);
                    this._applyButton.addEventListener('click', this._applyEdit);
                    this._clearFilterButton.addEventListener('click', this._clearFilter);
                    let config = this._config;
                    if (config.hasOwnProperty('MultiSelectMode') && (config.MultiSelectMode != null))
                        this._multiSelect = config.MultiSelectMode;
                    if (config.hasOwnProperty('HighlightSystemUsers') && (config.HighlightSystemUsers != null))
                        this._highlightSystemUsers = config.HighlightSystemUsers;
                    if (config.hasOwnProperty('SuppressContextBar') && config.SuppressContextBar)
                        this._suppressContextBar = true;
                    this._type.instanceReady(this.getHandle());
                    this._loadAllUsers(true);
                };
                this._callFailedHandler = (json) => {
                    
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                // Loads all users into the internal list, if it is currently empty or forceRefresh is true
                this._loadAllUsers = (forceRefresh) => {
                    
                    if ((this._allUsers.length > 0) && (!forceRefresh))
                        return;
                    // Need to specify response parameters - we just want the raw records
                    let request = {
                        PopulateUserGroups: false,
                        PopulateSecurityKeywords: false,
                        PopulateCustomData: false
                    };
                    this._core.Loader.genericServiceCallWithData('/SecurityAdmin.svc/rest/GetAllUserRecords', JSON.stringify(request), this._allUsersReturned, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._loadUserGroup = (group, forceRefresh) => {
                    
                    if ((this._currentGroupId == group.Id) && (this._groupUsers.length > 0) && (!forceRefresh))
                        return;
                    this._currentGroup = group;
                    this._currentGroupId = group.Id;
                    this._clearFilter();
                    this._hideOptions();
                    this._toggleMultiSelect(false);
                    this._showAllCheckbox.checked = false;
                    this._core.Functions.showElement(this._editIcon);
                    this._core.Functions.hideElement(this._editControls);
                    //this._populateUserTable(true);
                    // Need to specify response parameters - we just want the raw records
                    let request = {
                        PopulateUserGroups: false,
                        PopulateSecurityKeywords: false,
                        PopulateCustomData: false
                    };
                    this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/GetUserRecordsForGroupId/${group.Id}`, JSON.stringify(request), this._groupUsersReturned, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._allUsersReturned = (response) => {
                    if (response.hasOwnProperty('UserRecords') && response.UserRecords != null) {
                        this._allUsers = response.UserRecords;
                    }
                    else {
                        this._allUsers = [];
                        
                    }
                    let config = this._config;
                    if (!config.hasOwnProperty('Populate') || (config.Populate == null) || (config.Populate == true)) {
                        this._contextLabel.innerHTML = this._core.Locale.getTranslation('STR_WPT_LABEL_ALL_USERS');
                        if (!this._suppressContextBar)
                            this._core.Functions.showElement(this._contextBar);
                        this._populateUserTable();
                    }
                };
                this._groupUsersReturned = (response) => {
                    this._userIDsInGroup = [];
                    if (response.hasOwnProperty('UserRecords') && response.UserRecords != null) {
                        this._groupUsers = response.UserRecords;
                        this._groupUsers.forEach(user => {
                            this._userIDsInGroup.push(user.Id);
                        });
                        if (this._currentGroupId == 1)
                            this._core.Functions.hideElement(this._editIcon);
                        else
                            this._core.Functions.showElement(this._editIcon);
                        this._contextLabel.innerHTML = `${this._core.Locale.getTranslation('STR_WPT_LABEL_GROUP')}: ${this._currentGroup.Name}`;
                        if (!this._suppressContextBar)
                            this._core.Functions.showElement(this._contextBar);
                    }
                    else {
                        this._groupUsers = [];
                        
                    }
                    this._populateUserTableGroup();
                };
                this._populateUserTableGroup = () => {
                    
                    this._core.Functions.hideElement(this._loader);
                    // No records, no content
                    if (this._groupUsers.length == 0) {
                        
                        this._core.Functions.showElement(this._noRecords);
                    }
                    else {
                        
                        this._core.Functions.hideElement(this._noRecords);
                    }
                    // If we haven't already got a user list loaded, do it directly
                    if (!this._userListPopulated) {
                        this._populateUserTable(true);
                        this._core.Functions.showElement(this._tableBody);
                        return;
                    }
                    this._showHideNonGroupUsers(false);
                };
                this._showHideNonGroupUsers = (show) => {
                    
                    // Need to go through the user list making with the show/hide
                    let rowList = this._tableBody.querySelectorAll('tr.user-list-row');
                    if (rowList.length == 0)
                        return;
                    if (show) {
                        rowList.forEach(row => {
                            row.classList.remove('hidden');
                        });
                        this._core.Functions.hideElement(this._noRecords);
                    }
                    else {
                        let allHidden = true;
                        rowList.forEach(row => {
                            let id = Number(row.getAttribute('data-id'));
                            let checkBox = row.querySelector('.user-list-checkbox');
                            if (this._userIDsInGroup.indexOf(id) > -1) {
                                row.classList.remove('hidden');
                                checkBox.checked = true;
                                allHidden = false;
                            }
                            else {
                                row.classList.add('hidden');
                                checkBox.checked = false;
                            }
                        });
                        if (allHidden) {
                            
                            this._core.Functions.showElement(this._noRecords);
                        }
                    }
                    this._core.Functions.showElement(this._tableBody);
                };
                this._populateUserTable = (hideNonGroupUsers = false) => {
                    
                    this._core.Functions.hideElement(this._loader);
                    this._core.Functions.hideElement(this._tableBody);
                    this._tableBody.innerHTML = '';
                    // No records, no content
                    if (this._allUsers.length == 0) {
                        
                        this._core.Functions.showElement(this._noRecords);
                        return;
                    }
                    // We have a list of some kind
                    this._core.Functions.hideElement(this._noRecords);
                    // We can only hide nonGroupUsers if we have some
                    if (this._groupUsers.length == 0)
                        hideNonGroupUsers = false;
                    for (let i = 0; i < this._allUsers.length; i++) {
                        let user = this._allUsers[i];
                        let userId = user.Id.toString();
                        let row = this._tableBody.insertRow();
                        row.id = `userRow_${user.Id.toString()}`;
                        row.setAttribute('data-id', userId);
                        row.classList.add('user-list-row');
                        if ((user.Id < 101) && this._highlightSystemUsers)
                            row.classList.add('system-user');
                        if ((hideNonGroupUsers) && (this._userIDsInGroup.indexOf(user.Id) < 0))
                            row.classList.add('hidden');
                        let checkCell = row.insertCell();
                        checkCell.setAttribute('data-id', userId);
                        checkCell.id = `checkCell_${userId}`;
                        checkCell.classList.add('checkbox-cell');
                        if (!this._multiSelect)
                            checkCell.classList.add('hidden');
                        let checkBox = document.createElement('input');
                        checkBox.type = 'checkbox';
                        checkBox.classList.add('user-list-checkbox');
                        checkBox.id = `userCheck_${userId}`;
                        checkBox.setAttribute('data-id', userId.toString());
                        if (this._userIDsInGroup.indexOf(user.Id) > -1)
                            checkBox.checked = true;
                        checkCell.appendChild(checkBox);
                        let userCell = row.insertCell();
                        userCell.classList.add('vert-align', 'addCursor');
                        userCell.setAttribute('data-id', userId);
                        userCell.appendChild(document.createTextNode(user.Name));
                        userCell.addEventListener('click', this._userClicked);
                    }
                    this._userListPopulated = true;
                };
                this._toggleMultiSelect = (setting) => {
                    if (this._multiSelect == setting)
                        return;
                    this._multiSelect = setting;
                    let cellList = this._tableBody.querySelectorAll('.checkbox-cell');
                    
                    // Do the check once
                    if (this._multiSelect) {
                        cellList.forEach(cell => { this._core.Functions.showElement(cell); });
                    }
                    else {
                        cellList.forEach(cell => { this._core.Functions.hideElement(cell); });
                    }
                };
                this._showOptions = () => {
                    
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.showElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._tableOptions);
                    this._filterText.focus();
                };
                this._hideOptions = () => {
                    
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._tableOptions);
                    this._clearFilter();
                };
                this._editList = () => {
                    
                    // We are editing, so hide the icon
                    this._core.Functions.hideElement(this._editIcon);
                    this._core.Functions.showElement(this._editControls);
                    if (!this._multiSelect)
                        this._toggleMultiSelect(true);
                };
                this._showAllChanged = (event) => {
                    if (this._showAllCheckbox.checked) {
                        this._showHideNonGroupUsers(true);
                    }
                    else {
                        this._showHideNonGroupUsers(false);
                    }
                };
                this._clearFilter = () => {
                    
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    
                    let filterText = this._filterText.value.toLowerCase();
                    
                    let rowLength = this._tableBody.rows.length;
                    for (let r = 0; r < rowLength; r++) {
                        let row = this._tableBody.rows[r];
                        let cellLength = row.cells.length;
                        let filterMatched = false;
                        for (let c = 0; c < cellLength && !filterMatched; c++) {
                            let cell = row.cells[c];
                            if (cell.innerText.toLowerCase().indexOf(filterText) > -1) {
                                filterMatched = true;
                            }
                        }
                        if (filterMatched) {
                            row.style.display = "";
                        }
                        else {
                            row.style.display = "none";
                        }
                    }
                };
                this._cancelEdit = () => {
                    // Resets/cancels all settings for group edit
                    this._clearFilter();
                    this._hideOptions();
                    this._toggleMultiSelect(false);
                    this._showAllCheckbox.checked = false;
                    this._core.Functions.showElement(this._editIcon);
                    this._core.Functions.hideElement(this._editControls);
                    this._populateUserTable(true);
                    this._core.Functions.showElement(this._tableBody);
                };
                this._applyEdit = () => {
                    
                    // Create difference lists
                    let cbList = this._tableBody.querySelectorAll('input.user-list-checkbox');
                    let addList = [];
                    let removeList = [];
                    cbList.forEach(box => {
                        let userId = Number(box.getAttribute("data-id"));
                        if (box.checked) {
                            if (this._userIDsInGroup.indexOf(userId) == -1)
                                addList.push(userId);
                        }
                        else {
                            if (this._userIDsInGroup.indexOf(userId) != -1)
                                removeList.push(userId);
                        }
                    });
                    // Apply if non-empty
                    this._removeProcessed = false;
                    this._addProcessed = false;
                    if ((addList.length == 0) && (removeList.length == 0)) {
                        this._cancelEdit();
                        return;
                    }
                    // Process additions
                    if (addList.length > 0) {
                        
                        let addRequest = { UserIds: addList };
                        this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/AddUsersToGroupById/${this._currentGroupId}`, JSON.stringify(addRequest), this._groupAddProcessed, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else
                        this._addProcessed = true;
                    // Process removals
                    if (removeList.length > 0) {
                        
                        let removeRequest = { UserIds: removeList };
                        this._core.Loader.genericServiceCallWithData(`/SecurityAdmin.svc/rest/RemoveUsersFromGroupById/${this._currentGroupId}`, JSON.stringify(removeRequest), this._groupRemoveProcessed, {}, this._callErrorHandler, this._callFailedHandler);
                    }
                    else
                        this._removeProcessed = true;
                };
                this._groupAddProcessed = (response) => {
                    
                    if (this._removeProcessed) {
                        if (response.hasOwnProperty('UserGroupRecord') && (response.UserGroupRecord != null)) {
                            this._applyGroupChangesToUI(response.UserGroupRecord);
                        }
                        else
                            console.error("Group user addition procesed by server, but no user group record returned.");
                    }
                    else
                        this._addProcessed = true;
                };
                this._groupRemoveProcessed = (response) => {
                    
                    if (this._addProcessed) {
                        if (response.hasOwnProperty('UserGroupRecord') && (response.UserGroupRecord != null)) {
                            this._applyGroupChangesToUI(response.UserGroupRecord);
                        }
                        else
                            console.error("Group user removal procesed by server, but no user group record returned.");
                    }
                    else
                        this._removeProcessed = true;
                };
                this._applyGroupChangesToUI = (group) => {
                    
                    // Need to (re)set all the "current status" variables
                    this._currentGroup = group;
                    this._currentGroupId = group.Id;
                    this._userIDsInGroup = [];
                    if (this._currentGroup.hasOwnProperty('Members') && (this._currentGroup.Members != null)) {
                        
                        this._groupUsers = this._currentGroup.Members;
                        this._groupUsers.forEach(user => {
                            
                            this._userIDsInGroup.push(user.Id);
                        });
                    }
                    // This will reset the UI but with the new group in place
                    this._cancelEdit();
                };
                this.groupSelected = (group) => {
                    this._loadUserGroup(group, false);
                };
                this._userClicked = (event) => {
                    let config = this._config;
                    let clickedItem = event.currentTarget;
                    let userId = Number(clickedItem.getAttribute('data-id'));
                    this._lastSelectedUser = this._allUsers.find(user => user.Id == userId);
                    this._tableBody.querySelectorAll('.user-selected').forEach(node => {
                        node.classList.remove('user-selected');
                    });
                    if (this._multiSelect) {
                        let checkBox = this._tableBody.querySelector(`#userCheck_${userId}`);
                        if (checkBox) {
                            if (checkBox.checked)
                                checkBox.checked = false;
                            else
                                checkBox.checked = true;
                        }
                    }
                    else {
                        this._tableBody.querySelector(`tr[data-id="${userId}"`).classList.add('user-selected');
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.USER_SELECTED);
                        navEvent.ActivationID = userId;
                        navEvent.PrimaryContext = this._lastSelectedUser;
                        let targetLayoutName = this._currentLayout;
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                        navEvent.Layout = targetLayoutName;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                
                this._instanceSelector = config.PlaceHolder;
            }
            get MultiSelect() {
                return this._multiSelect;
            }
            set MultiSelect(multi) {
                if (multi != this._multiSelect) {
                    this._toggleMultiSelect(multi);
                }
            }
            activate(context) {
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.USER_GROUP_SELECTED:
                        this.groupSelected(context.PrimaryContext);
                        break;
                }
            }
        }
        UserListWidgetInstanceClass.HtmlData = null;
        Widgets.UserListWidgetInstanceClass = UserListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
